export const dashboardConstants = {
    DASHBOARD_DATA: "DASHBOARD_DATA",
    RECOMMENDATIONAN_DATA: "RECOMMENDATIONAN_DATA",
    RANKING: "RANKING",
    SCORE: "SCORE",
    NOOFCOMPETITION:"No. of Competitions",
    NA: "N/A" 
  };